<template>
	<div>
		<div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
			<div class="foot-tab-head">
				<div class="foot-tab-row-label" :class="{'!w-[135px] shadow-[-1px_0_0_0_#3A4B64]' : windowWidth < 540}">
					<span class="cursor-pointer underline zt-hover min-w-[18px] pl-[10px] whitespace-nowrap"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
					<span class="cursor-pointer underline zt-hover truncate"
					      :class="{ '!no-underline' : sortColumn === 'name' }"
					      @click="sortTable('name', $event)">{{ getTitleString(phaseString) }}</span>
				</div>
				<div class="flex">
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'matches' }"
					     @click="sortTable('matches', $event)"><div>M</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'Z/Z' }"
					     @click="sortTable('Z/Z', $event)"><div>W/W</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'Z/R' }"
					     @click="sortTable('Z/R', $event)"><div>W/R</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'Z/P' }"
					     @click="sortTable('Z/P', $event)"><div>W/P</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'R/Z' }"
					     @click="sortTable('R/Z', $event)"><div>R/W</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'R/R' }"
					     @click="sortTable('R/R', $event)"><div>R/R</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'R/P' }"
					     @click="sortTable('R/P', $event)"><div>R/P</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'P/Z' }"
					     @click="sortTable('P/Z', $event)"><div>P/W</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'P/R' }"
					     @click="sortTable('P/R', $event)"><div>P/R</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'P/P' }"
					     @click="sortTable('P/P', $event)"><div>P/P</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'points' }"
					     @click="sortTable('points', $event)"><div>P</div></div>
				</div>
			</div>
			<div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id), '!pl-0' : window.size.mobile, '!border-b-0 !rounded-b-zt': index === leagueTable.length - 1 }"
			     :key="team.team_id"
			     v-for="(team, index) in leagueTable">
				<div class="foot-tab-row-label"
             :class="[{ 'blur-right shadow-[-1px_0_0_0_#3A4B64] !w-[135px]' : windowWidth < 540, '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id)}, currentSubTab === 'all' && window.size.mobile ? getSpotDetails('', team.position) : '' ]">
					<p class="flex items-center" :class="{ 'pl-2.5 pr-1' : window.size.mobile }">
						<span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
            <a v-if="!selectedTeamsIds.includes(+team.team_id)"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
               class="no-default-style" :class="{ 'zt-hover': team.clickable }">
              <span class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
            </a>
            <span v-else class="flex items-center mr-2 aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
						<a v-if="!selectedTeamsIds.includes(+team.team_id)"
               class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </a>
						<span v-else class="text-ellipsis line-clamp-1 break-all">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </span>
					</p>
				</div>
        <Transition appear name="fade" mode="out-in">
          <div :key="filterKey" class="flex">
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
              <div>{{ allMatches(team) }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'Z/Z' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'z', 'z') }">{{ getHtFTValue(team, 'z', 'z') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'Z/R' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'z', 'r') }">{{ getHtFTValue(team, 'z', 'r') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'Z/P' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'z', 'p') }">{{ getHtFTValue(team, 'z', 'p') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'R/Z' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'r', 'z') }">{{ getHtFTValue(team, 'r', 'z') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'R/R' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'r', 'r') }">{{ getHtFTValue(team, 'r', 'r') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'R/P' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'r', 'p') }">{{ getHtFTValue(team, 'r', 'p') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'P/Z' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'p', 'z') }">{{ getHtFTValue(team, 'p', 'z') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'P/R' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'p', 'r') }">{{ getHtFTValue(team, 'p', 'r') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'P/P' }">
              <div :class="{ 'marked-box' : isHighestValue(team, 'p', 'p') }">{{ getHtFTValue(team, 'p', 'p') }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'points' }">
              <div>{{ getPoints(team) }}</div>
            </div>
          </div>
        </Transition>
			</div>
		</div>
	</div>
</template>

<script>
import football_mixin from "../../mixins/football_mixin";
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'HtftTable',
	components: {TeamImg},
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
		teams: Array,
		filters: Array,
		details: Object,
		selectedTeamsIds: {
			type: Array,
			default: []
		},
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	data() {
		return {
			previousSortColumn: null,
			sortColumn: 'points',
			sortAscending: 1,
			displayedTable: 'all',
			currentSubTab: this.filters[1] ?? 'all',
			windowWidth: window.innerWidth,
			teamsSorted: [],
			isLpSet: false,
		}
	},
	watch: {
		filters(newVal) {
			setTimeout(() => {
				this.currentSubTab = newVal[1];
				this.setHtFt();
				this.leagueTable.sort(this.sortTeams).forEach((team, i) => { team.currentTablePosition = i + 1; });
			}, 300);
		},
	},
	mounted() {
    this.setHtFt();
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    })
    this.teamsSorted = this.teams;
    this.teamsSorted.sort(this.sortTeams).forEach((team, i) => { team.position = i + 1; });
    this.setHtFt();
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    boxSize() {
      return this.view === 'compact' ? '22px' : '25px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0) {
				return this.teamsSorted.sort(this.sortTeams);
			} else {
				return this.teamsSorted;
			}
		},
	},
	methods: {
		getHtFt(team, ht, ft) {
			if (ht === 'z') {
				if (ft === 'z') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				} else if (ft === 'r') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				} else if (ft === 'p') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				}
			} else if (ht === 'r') {
				if (ft === 'z') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				} else if (ft === 'r') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				} else if (ft === 'p') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) === parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				}
			} else if (ht === 'p') {
				if (ft === 'z') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				} else if (ft === 'r') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) === parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				} else if (ft === 'p') {
					if (this.currentSubTab === 'all') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if ((match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								|| (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals)))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'home') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.localteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) < parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) < parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
					else if (this.currentSubTab === 'away') {
						return this.getTeamMatches(team).reduce((sum, match) => {
							if (match.visitorteam_id === team.team_id && parseInt(match.localteam_stats.fh_goals) > parseInt(match.visitorteam_stats.fh_goals) && parseInt(match.localteam_stats.ft_goals) > parseInt(match.visitorteam_stats.ft_goals))
								return sum + 1;
							else
								return sum;
						}, 0);
					}
				}
			}
		},
		sortTeams(a, b) {
			let diff = 0;
			if (this.sortColumn === 'name') {
				if (this.sortAscending) {
					diff = a.name.localeCompare(b.name);
				} else {
					diff = b.name.localeCompare(a.name);
				}
				return diff;
			}
			switch (this.sortColumn.toLowerCase()) {
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'z/z':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'z', 'z') - this.getHtFTValue(b, 'z', 'z');
					} else {
						diff = this.getHtFTValue(b, 'z', 'z') - this.getHtFTValue(a, 'z', 'z');
					}
					break;
				case 'z/r':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'z', 'r') - this.getHtFTValue(b, 'z', 'r');
					} else {
						diff = this.getHtFTValue(b, 'z', 'r') - this.getHtFTValue(a, 'z', 'r');
					}
					break;
				case 'z/p':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'z', 'p') - this.getHtFTValue(b, 'z', 'p');
					} else {
						diff = this.getHtFTValue(b, 'z', 'p') - this.getHtFTValue(a, 'z', 'p');
					}
					break;
				case 'r/z':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'r', 'z') - this.getHtFTValue(b, 'r', 'z');
					} else {
						diff = this.getHtFTValue(b, 'r', 'z') - this.getHtFTValue(a, 'r', 'z');
					}
					break;
				case 'r/r':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'r', 'r') - this.getHtFTValue(b, 'r', 'r');
					} else {
						diff = this.getHtFTValue(b, 'r', 'r') - this.getHtFTValue(a, 'r', 'r');
					}
					break;
				case 'r/p':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'r', 'p') - this.getHtFTValue(b, 'r', 'p');
					} else {
						diff = this.getHtFTValue(b, 'r', 'p') - this.getHtFTValue(a, 'r', 'p');
					}
					break;
				case 'p/z':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'p', 'z') - this.getHtFTValue(b, 'p', 'z');
					} else {
						diff = this.getHtFTValue(b, 'p', 'z') - this.getHtFTValue(a, 'p', 'z');
					}
					break;
				case 'p/r':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'p', 'r') - this.getHtFTValue(b, 'p', 'r');
					} else {
						diff = this.getHtFTValue(b, 'p', 'r') - this.getHtFTValue(a, 'p', 'r');
					}
					break;
				case 'p/p':
					if (this.sortAscending) {
						diff = this.getHtFTValue(a, 'p', 'p') - this.getHtFTValue(b, 'p', 'p');
					} else {
						diff = this.getHtFTValue(b, 'p', 'p') - this.getHtFTValue(a, 'p', 'p');
					}
					break;
				case 'position':
					if (this.currentTab === 'all') {
						if (this.sortAscending) {
							diff = a.position - b.position;
						} else {
							diff = b.position - a.position;
						}
					} else {
						if (this.sortAscending) {
							diff = a.currentTablePosition - b.currentTablePosition;
						} else {
							diff = b.currentTablePosition - a.currentTablePosition;
						}
					}
					break;
				case 'points':
				default:
					if (this.sortAscending) {
						diff = this.getPoints(b) - this.getPoints(a);
					} else {
						diff = this.getPoints(a) - this.getPoints(b);
					}
					break;
			}
			return diff;
		},
		getHtFtAndSetPoints(team, ht, ft) {
			const sum = this.getHtFt(team, ht, ft);
			const teamIndex = this.teams.findIndex(t => team.team_id === t.team_id);
			this.teams[teamIndex][`${ht}-${ft}`] = sum;
		},
		isHighestValue(team, ht, ft) {
			const values = [
				team['z-z'],
				team['z-r'],
				team['z-p'],
				team['r-z'],
				team['r-r'],
				team['r-p'],
				team['p-z'],
				team['p-r'],
				team['p-p'],
			];
			const maxVal = Math.max(...values);
			const val = team[`${ht}-${ft}`];

			return val === maxVal && maxVal !== 0;
		},
    setHtFt() {
      let type = ['z', 'r', 'p'];
      this.teams.forEach(team => {
        type.forEach((ht) => {
          type.forEach((ft) => {
            this.getHtFtAndSetPoints(team, ht, ft)
          })
        })
      })
    },
    getHtFTValue(team, ht, ft) {
      const teamIndex = this.teams.findIndex(t => team.team_id === t.team_id);
      if (teamIndex !== -1) {
        return this.teams[teamIndex][`${ht}-${ft}`]
      } else {
        return 0;
      }
    }
	}
}
</script>
<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.blur-right {
	@apply after:content-[''] after:bg-zt-more/25 after:shadow-[1px_0_2px_0_rgba(147,163,186,0.3)] after:w-[1px] after:top-0 after:h-full after:right-[2px] after:z-20 after:absolute;
}
.marked-box {
  height: v-bind(boxSize);
  width: v-bind(boxSize);
	@apply bg-zt-more text-center grid place-items-center rounded-zt;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>